import React from 'react';
import styled from 'styled-components';

import GalaryBlock from '../GalaryBlock/GalaryBlock';
import HotelDetailsLoader from '../HotelDetailsLoader/HotelDetailsLoader';

const SrpCardLeftComponent = () => (
  <SrpCardLeftComponentWrapDiv>
    <GalaryBlock></GalaryBlock>
    <HotelDetailsLoader></HotelDetailsLoader>
  </SrpCardLeftComponentWrapDiv>
);

export default SrpCardLeftComponent;

const SrpCardLeftComponentWrapDiv = styled.div(
  props => `
  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  margin: 0 auto;
  width:75%;
  border-right: ${props.theme.misc.border.base} solid ${props.theme.colors.grey.lineGrey};
  padding:${props.theme.spacing.large.l15}
`,
);
